import * as yup from "yup";

export const phoneCallSchema = yup
  .object({
    sender: yup.string().required("Sender is required"),
    // recipient: yup.number().min(99999999, 'Phone number is invalid length').max(999999999999, 'Phone number is invalid').required("Recipient is required"),
    recipient: yup
      .string()
      .required("Recipient is required")
      .matches(/^\+?\d+$/, "Recipient must be a valid phone number"),

    callDuration: yup
      .number("Call Duration must be a number")
      .transform((value, originalValue) => {
        // If the value is not a valid number, return NaN to trigger the error.
        return isNaN(originalValue) ? NaN : value;
      })
      .required("Call Duration is required")
      .positive("Call Duration must be a positive number")
      .min(1, "Call Duration must not be zero") // Ensure value is greater than 0
      .integer("Call Duration must be an integer")
      .typeError("Call Duration must be a valid number"),

    callNotes: yup.string(),
    createBy: yup
      .mixed()
      .test(
        "is-valid",
        "Create By must be a string or an array of strings",
        (value) => {
          if (value === null || value === undefined) return true;
          if (typeof value === "string") return true;
          if (Array.isArray(value))
            return value.every((v) => typeof v === "string");
          return false;
        }
      )
      .nullable(),
    createByLead: yup.string(),
    category: yup.string(),
    subject: yup
      .string()
      .trim()
      .required("Call Subject is required")
      .min(1, "Subject must be at least 1 characters long")
      .max(255, "Subject must be at most 255 characters long"),

    startDate: yup
      .date()
      .transform((value, originalValue) => {
        console.log("Transforming startDate:", value, originalValue);
        // If it's already a Date object, return it
        if (value instanceof Date) return value;

        // If it's a string in datetime-local format, convert to Date
        if (typeof originalValue === 'string' && originalValue) {
          const date = new Date(originalValue);
          return isNaN(date.getTime()) ? new Date('') : date;
        }

        return value;
      })
      .required("Date & Time is required"),

    callType: yup.string().required("Call Type is required"),
    status: yup.string().required("Status is required"),

    createByDeal: yup
      .mixed()
      .test(
        "is-valid",
        "Attendees Deal must be a string or an array of strings",
        (value) => {
          // Allow empty or null values
          if (value === null || value === undefined) return true;

          // Check if it's a string
          if (typeof value === "string") return true;

          // Check if it's an array of strings
          if (Array.isArray(value)) {
            return value.every((v) => typeof v === "string");
          }

          return false;
        }
      )
      .nullable(),

    createByAccount: yup
      .mixed()
      .test(
        "is-valid",
        "Attendees Account must be a string or an array of strings",
        (value) => {
          // Allow empty or null values
          if (value === null || value === undefined) return true;

          // Check if it's a string
          if (typeof value === "string") return true;

          // Check if it's an array of strings
          if (Array.isArray(value)) {
            return value.every((v) => typeof v === "string");
          }

          return false;
        }
      )
      .nullable(),
  })
  .test(
    "createBy-or-createByLead-or-createByDeal-or-createByAccount-required",
    "At least one of Create By, Create By Lead, Attendees Deal, or Attendees Account is required",
    function (value) {
      const { createBy, createByLead, createByDeal, createByAccount } = value;

      // Only checking if any of the fields have a value
      if (!createBy && !createByLead && !createByDeal && !createByAccount) {
        return this.createError({
          path: "createBy",
          message:
            "At least one of Create By, Create By Lead, Attendees Deal, or Attendees Account is required",
        });
      }

      return true;
    }
  );
